import styled from 'styled-components'

export const Description = styled.p`
  text-align: left;
  margin: 0 0 25px;
`
